import {
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
    Button,
    FormControl, InputLabel, Select, MenuItem,
  } from "@mui/material";
  import React, { Dispatch, SetStateAction, useCallback, useEffect, useState } from "react";
  import { EventBusEventsEnum } from "../../enums/EventBusEventsEnum";
  import EventBus from "../../EventBus";
  import { CustomSnackbarTypes } from "./CustomSnackBar";
import { PartyTag } from "../ChefForParty/ChefForPartList";
import { getReasonCategory } from "./constants/constant";
import ReasonSubreasonModuleEnum from "../../enums/ReasonSubreasonModuleEnum";
import { ActionTypeEnum } from "../../enums/ActionTypeEnum";
import ChefForPartyService from "../../services/ChefForPartyService";
import { useRefresh, useUnselectAll } from "react-admin";
  
  interface InputProps {
    open: boolean;
    setOpen: Dispatch<SetStateAction<boolean>>;
    data: any;
    isMultiple?: boolean
  }

let chefForPartyService =  new ChefForPartyService();  
  
  
  const UpdateLeadTagDialog = (props: InputProps) => {
    const [selectedTag, setSelectedTag] = useState<any>(null);
    const [categoryItems,setCategoryItems]=useState<any>([])
    const [reasonCategory, setReasonCategory] = useState<any>(null);
    const [loading, setLoading] = useState<boolean>(false);
    const refresh = useRefresh();
    const unselectAll = useUnselectAll("ChefForParty");
    
    const loadData = useCallback(async () => {
        const sampleReasonSubReason = await getReasonCategory(ReasonSubreasonModuleEnum.CHEF_FOR_PARTY,ActionTypeEnum.PARTY_LEAD_TAG_LOST);
        setCategoryItems(sampleReasonSubReason);
    }, []);
  
    useEffect(()=>{
        loadData();
    },[loadData])  
  
    const handleSubmit = async () => {
        let payload = {
            status: selectedTag,
            lostReason: reasonCategory ?? null
        }
        chefForPartyService.updateLeadTag(props.data?.id, payload)
            .then(() => {
                EventBus.emitEvent(EventBusEventsEnum.SNACKBAR_SHOW, {
                    message: "Successful",
                    type: CustomSnackbarTypes.SUCCESS,
                });
                setSelectedTag('');
                setReasonCategory('');
                props.setOpen(false);
                window.location.reload();
            } 
            ).catch((err) => {
                EventBus.emitEvent(EventBusEventsEnum.SNACKBAR_SHOW, {
                    message: "Something went wrong",
                    type: CustomSnackbarTypes.ERROR,
                });
                setSelectedTag('');
                setReasonCategory('');
            })
    };

    const updateMultipleLeads = async () => {
        console.log(props?.data);
        
        let successCount = 0;
        let failure = 0;

        const promises = props?.data?.map(async (element: number) => {
        let payload = {
            status: selectedTag,
            lostReason: reasonCategory ?? null
        }

          try {
            setLoading(true);
            const res = await chefForPartyService.updateLeadTag(element, payload);
            if(res){
                successCount++
            }
          } catch (error) {
            failure++;
            console.error(error);
          }
        });

        await Promise.all(promises);
        setLoading(false);
        EventBus.emitEvent(EventBusEventsEnum.SNACKBAR_SHOW, {
          message: `Leads updated for ${successCount} visits and failed for ${failure} visits`,
          type: CustomSnackbarTypes.SUCCESS,
        });
        refresh();
        unselectAll();
        props.setOpen(false)
      }
  
  
    return (
      <Dialog open={props.open} scroll={"paper"}>
        <DialogTitle>Set Party Tag</DialogTitle>
        {
            !loading &&
            <DialogContent>
          <FormControl fullWidth >
            <InputLabel id="Tag_slot">Select Type</InputLabel>
            <Select
                labelId="Tag_slot"
                id="Select Type"
                label="Select Service"
                value={selectedTag}
                onChange={(event) => setSelectedTag(event.target.value)}
            >
              
              {Object.keys(PartyTag).map((e: any) => (
                <MenuItem key={e} value={e}>
                  {e}
                </MenuItem>
            ))}
              
            </Select>
          </FormControl>
          {
            (selectedTag === PartyTag.JUNK || selectedTag === PartyTag.LOST) &&
            <FormControl style={{ width: 500 }}>
                <InputLabel id="select-label">Select Reason</InputLabel>
                <Select
                    labelId="select-label"
                    id="select-label"
                    defaultValue="Select a reason"
                    value={reasonCategory}
                    onChange={(e) => setReasonCategory(e.target.value)}
                >
                    {categoryItems.map((item: any) => {
                      return (
                        <MenuItem key={item.category} value={item.category}>
                          {item.category}
                        </MenuItem>
                      );
                    })}
                </Select>
            </FormControl>
          }
        </DialogContent>
        }
        <DialogActions>
          <Button
            variant="contained"
            color={"success"}
            onClick={() => {
              !props?.isMultiple ? handleSubmit() : updateMultipleLeads();
            }}
            size={"large"}
          >
            Submit
          </Button>
          <Button
            variant="contained"
            color={"error"}
            onClick={() => {
              props.setOpen(false);
              setReasonCategory(null);
            }}
            size={"large"}
          >
            Cancel
          </Button>
        </DialogActions>
      </Dialog>
    );
  };
  
  export default UpdateLeadTagDialog;
  